import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import { createRoot } from "react-dom/client"
import WeeklyRecurringScheduler from "./WeeklyRecurringScheduler"

const MySwal = withReactContent(Swal)

export const openSchedulerModal = async (initialPlanification) => {
  let planification = {}

  return MySwal.fire({
    title: "Planification récurrente",
    html: "<div id='react-scheduler-container'></div>", // Mount point
    showCancelButton: true,
    showDenyButton: true,
    confirmButtonText: "Valider",
    denyButtonText: "Continuer sans planification",
    denyButtonColor: "#28a745",
    cancelButtonText: "Annuler",
    allowOutsideClick: false,
    allowEscapeKey: false,
    focusConfirm: false,
    width: "70%",
    willOpen: () => {
      const container = document.getElementById("react-scheduler-container")
      if (container) {
        const root = createRoot(container)
        root.render(
          <WeeklyRecurringScheduler
            initialPlanification={initialPlanification}
            onPlanificationChange={(planif) => (planification = planif)}
          />
        )
      }
    },
    preConfirm: () => {
      if (
        !planification.startDate ||
        !planification.endDate ||
        !planification.recurrenceInterval ||
        !planification.templateEvents ||
        planification.templateEvents.length === 0
      ) {
        Swal.showValidationMessage(
          "Veuillez remplir tous les champs et sélectionner au moins un créneau de diffusion !"
        )
        return false
      }
      return planification
    },
  }).then((result) => {
    if (result.isConfirmed) {
      return result.value // Planification confirmed
    } else if (result.isDenied) {
      return null // No planification selected
    } else {
      return false // Modal closed or cancelled
    }
  })
}
